import createModule from "../createModule"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import view from "./view"
import { getWatchlistDetails, getFiles, getUploadConfig, getScanResult, getUploadOption, getUploadDateTime, getUploadedFiles } from "./selectors"
import { getSteps } from "./selectors/steps"
import { getActiveStepFromParams } from "helpers/upload-steps"
import { Creators } from "./model"
import withUrlParams from "hocs/withUrlParams"
import withNavigate from "hocs/withNavigate"
import withOutletContext from "hocs/withOutletContext"
import { MODELS_QUERY, getModels } from "resources/models"

export default withUrlParams(withNavigate(withOutletContext(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    watchlistId: props.params.watchlistId,
  }),
  required: ["account", "watchlistId"],
  data: [{
    resource: "portfolios",
    as: null,
    url: ({ account }) => `/api/${account}/portfolios`,
  }, {
    resource: "watchlist",
    as: null,
    url: ({ watchlistId }) => ({
      id: `watchlist-${watchlistId}`,
      query: `query ($id: String!) {
        watchlist (id: $id) {
          id
          name
          alias
          count
        }
      }`,
      variables: {
        id: watchlistId,
      },
    }),
  }, {
    ...MODELS_QUERY,
    as: null,
  }],
  mapStateToProps: (state, props) => ({
    files: getFiles(state),
    watchlistDetails: getWatchlistDetails(state),
    activeStep: getActiveStepFromParams(props.params),
    steps: getSteps(state),
    uploadConfig: getUploadConfig(),
    scanResult: getScanResult(state),
    uploadOption: getUploadOption(state),
    uploadDateTime: getUploadDateTime(state),
    uploadedFiles: getUploadedFiles(state),
    models: getModels(state),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
  },
}))))
